<template>
  <main class="content">
    <!-- content -->
    <section class="intro">
      <div class='container'>
        <div class="intro__wrapper">
          <div class="intro__content">
            <span class="intro__info">Российская общественная некоммерческая организация Экспертный центр ПАУ</span>
            <h1 class="intro__title">Юрист уже решил вашу проблему</h1>
            <h2 style="font-size: 20px; margin: 20px 0">Лучшие юристы работают на вас. Поэтому еще более эффективно, но дешевле.</h2>
            <p class="intro__subtitle">
              Решите свой вопрос сами!
              Сделайте это лучше. Быстрее. Эффективнее.
              Дешевле. Без риска
            </p>
            <div class="intro__video">
              <a class="intro__btn" @click="showModal(5,'<iframe src=\'https://www.youtube.com/embed/cLPx7HrVta4\'></iframe>')" target="_blank">
                <picture><source srcset="/static/assets/img/intro/play.svg" type="image/webp"><img src="/static/assets/img/intro/play.svg" alt="" /></picture>
                <span>Смотреть видео</span>
              </a>
            </div>
          </div>
          <div class="intro__picture">
            <picture><source srcset="/static/assets/img/intro/1.svg" type="image/webp"><img src="/static/assets/img/intro/1.svg" alt="" /></picture>
          </div>
        </div>

      </div>
    </section>

    <section class="items">
      <div class='container'>
        <div class="items__wrapper items-inner">
          <div class="items-inner__item">
            <div class="items-inner__title">Есть проблема требующая вмешательства адвоката?</div>
            <ul class="items-inner__list">
              <li class="items-inner__li">— Запишитесь на вебинар на удобные день и время</li>
              <li class="items-inner__li">— Решение любого вопроса всего за 350 рублей</li>
              <li class="items-inner__li">— Решите свой вопрос без обращения к дорогим юристам, экономя минимум 15000 рублей</li>
              <li class="items-inner__li">— Без риска</li>
            </ul>
            <div class="items-inner__sub">Как все происходит:</div>
            <ul class="items-inner__sublist">
              <li class="items-inner__link">На онлайн-вебинаре разберем вашу ситуацию</li>
              <li class="items-inner__link">Выработаем пошаговый план Ваших действий на основе аналогичных выигранных дел</li>
              <li class="items-inner__link">Подготовим Вас к суду</li>
              <li class="items-inner__link">Поможем выиграть дело</li>
            </ul>
          </div>
          <div class="items-inner__item">
            <div class="items-inner__title">Вы сможете решить свою проблему всего за 1 час</div>
            <div class="items-inner__sub">По итогам интенсива Вы:</div>
            <ul class="items-inner__list">
              <li class="items-inner__li">— Разберетесь в юридическом вопросе: Пункты, статьи, правила, нормы, разъяснения</li>
              <li class="items-inner__li">— Сможете сформировать свои доказательства для того чтобы выиграть дело</li>
              <li class="items-inner__li">— Выстроите линию защиты по своему делу</li>
              <li class="items-inner__li">— Сформируете памятку-матрицу по своему делу: что делать, как делать, когда</li>
              <li class="items-inner__li">— Подготовите и подадите нужные документы в соответствующие инстанции</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <Shedule :timetable.sync="timetable"/>

    <section class="program">
      <div class='container'>
        <div class="program__wrapper">
          <h1 class="program__title">Наши программы</h1>
          <div class="program__inner">
            <div class="wrapper__inner">
              <div class="program-item" v-for="group in groupsOA" :key="group.id">
              <div class="program-item__img" v-if="group.cf[337]">
                        <span>
                            <picture>
                              <img class="program-item__desktop" :src="group.cf[337]" :alt="group.name" />
                            </picture>
                            <picture>
                              <img class="program-item__mobile" :src="group.cf[337]" :alt="group.name" />
                            </picture>
                        </span>
                <div class="program-item__head">{{group.name}}</div>
              </div>
              <h2 class="program-item__title">{{group.name}}</h2>
              <div class="program-item__text">
                <p v-if="group.cf[463]" v-html="group.cf[463]"></p>
              </div>
              <router-link class="program-item__footer" :to="'/urist/group/' + group.id">
                Подробнее <span> <picture><source srcset="/static/assets/img/program/arrow.svg" type="image/webp"><img src="/static/assets/img/program/arrow.svg" width="16" height="8" alt="" /></picture> </span>
              </router-link>
            </div>
              <div class="program-item" v-for="group in groupsSmart" :key="group.id">
                <div class="program-item__img" v-if="group.cf[436]">
                        <span>
                            <picture>
                              <img class="program-item__desktop" :src="group.cf[436]" :alt="group.name" />
                            </picture>
                            <picture>
                              <img class="program-item__mobile" :src="group.cf[436]" :alt="group.name" />
                            </picture>
                        </span>
                  <div class="program-item__head">{{group.name}}</div>
                </div>
                <h2 class="program-item__title">{{group.name}}</h2>
                <div class="program-item__text">
                  <p v-html="group.html"></p>
                </div>
                <router-link class="program-item__footer" :to="'/smart/group/' + group.id">
                  Подробнее <span> <picture><source srcset="/static/assets/img/program/arrow.svg" type="image/webp"><img src="/static/assets/img/program/arrow.svg" width="16" height="8" alt="" /></picture> </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about">
      <div class='container'>
        <div class="about__wrapper wrapper-about">
          <h2 class="wrapper-about__title">О нас</h2>
          <div class="wrapper-about__inner inner-about">
            <div class="inner-about__item">
              <span class="inner-about__picture"> <picture><source srcset="/static/assets/img/about/1.svg" type="image/webp"><img src="/static/assets/img/about/1.svg" width="44" height="44" alt="" /></picture> </span>
              <h2 class="inner-about__text">Эксперты в СМИ</h2>
            </div>
            <div class="inner-about__item">
              <span class="inner-about__picture"> <picture><source srcset="/static/assets/img/about/2.svg" type="image/webp"><img src="/static/assets/img/about/2.svg" width="44" height="44" alt="" /></picture> </span>
              <h2 class="inner-about__text">Авторы книг</h2>
            </div>
            <div class="inner-about__item">
              <span class="inner-about__picture"> <picture><source srcset="/static/assets/img/about/3.svg" type="image/webp"><img src="/static/assets/img/about/3.svg" width="44" height="44" alt="" /></picture> </span>
              <h2 class="inner-about__text">Опыт работы в судах, МВД, прокуратуре</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="work">
      <div class='container'>
        <div class="work__wrapper">
          <h2 class="work__title">Как это работает</h2>
          <div class="work__inner inner-work">
            <div class="inner-work__col">
              <span class="inner-work__pictures"> <picture><source srcset="/static/assets/img/work/1.svg" type="image/webp"><img src="/static/assets/img/work/1.svg" width="36" height="36" alt="" /></picture> </span>
              <div class="inner-work__text">
                <h3 class="inner-work__title">10 лет</h3>
                <p class="inner-work__subtitle">Минимальный опыт работы автоюриста</p>
              </div>
            </div>
            <div class="inner-work__col">
              <span class="inner-work__pictures"> <picture><source srcset="/static/assets/img/work/2.svg" type="image/webp"><img src="/static/assets/img/work/2.svg" width="36" height="36" alt="" /></picture> </span>
              <div class="inner-work__text">
                <h3 class="inner-work__title">Всего 1 час</h3>
                <p class="inner-work__subtitle">Всего за 1 час и 350 рублей Вы получите конкретное решение, которое у юристов стоит десятки тысяч</p>
              </div>
            </div>
            <div class="inner-work__col">
              <span class="inner-work__pictures"> <picture><source srcset="/static/assets/img/work/3.svg" type="image/webp"><img src="/static/assets/img/work/3.svg" width="36" height="36" alt="" /></picture> </span>
              <div class="inner-work__text">
                <h3 class="inner-work__title">Хочешь сделать хорошо? Сделай сам</h3>
                <p class="inner-work__subtitle">Проверенный способ решения вопросов - ежедневно им пользуются 50+ человек</p>
              </div>
            </div>
          </div>
          <div class="intro__video work-video">
            <button class="intro__btn"></button>
          </div>
        </div>
      </div>
    </section>

    <section class="question">
      <div class='container'>
        <div class="question__wrapper">
          <div class="question__item">
            <h1 class="question__title">Как можно самому выиграть дело?</h1>
            <div class="question__text">
              <p>Вы - не юрист. Поэтому сотни наших юристов, которые учились и имеют большой опыт в решении конкретного вопроса, сделали всё за вас. Не важно, какой вам нужен результат: взыскать деньги, обанкротиться самостоятельно, выиграть спор по квартире, взыскать выплаты от работодателя, или добиться чего-то ещё - юристы уже всё сделали.</p>
              <p>Подготовим вас к суду, чтобы вы выиграли дело сами - без обращения к дорогим юристам и адвокатам.</p>
            </div>
          </div>

        </div>
      </div>
    </section>

  </main>
</template>

<script>
import axios from '@/router/http'
// import Swiper from 'swiper/js/swiper'
import Shedule from './include/shedule'
export default {
  name: 'HelloWorld',
  components: {Shedule},
  data () {
    return {
      timetable: [],
      news: [],
      groupsOA: [],
      groupsSmart: []
    }
  },
  mounted () {
    axios.get('https://smart.v-avtoservice.com/list/get-time-table').then(response => {
      this.timetable = response.data
    })
    axios.get('https://urist2.v-avtoservice.com/list/get-lists?id=29').then(response => {
      this.groupsOA = response.data
    })
    axios.get('https://smart.v-avtoservice.com/list/get-lists?id=36').then(response => {
      this.groupsSmart = response.data
    })
  },
  methods: {
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue